import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PrescriptionData {
  vitals: string;
  bp: string;
  spo2: string;
  height: string;
  weight: string;
  remarks: string;
  diagnosis: string;
  history: string;
  comments: string;
  is_edit_allowed: boolean;
  status: string;
  visit_date?: string;
  next_visit_date?: Date | string | null;
  early_visit_reason?: string;
  isEarlyVisit?: boolean;
  no_medicine?: boolean;
  arr?: any[];
  serviceArr?: any[];
  treatmentArr?: any[];
  [key: string]: any;
}

interface PrescriptionState {
  prescriptionData: PrescriptionData;
  loading: boolean;
  visitId: string | null;
}

const initialState: PrescriptionState = {
  prescriptionData: {
    vitals: "",
    bp: "",
    spo2: "",
    height: "",
    weight: "",
    remarks: "",
    diagnosis: "",
    history: "",
    comments: "",
    is_edit_allowed: true,
    status: "",
    visit_date: "",
    next_visit_date: null,
    early_visit_reason: "",
    isEarlyVisit: false,
    no_medicine: false,
    arr: [],
    serviceArr: [],
    treatmentArr: [],
  },
  loading: false,
  visitId: null,
};

const prescriptionSlice = createSlice({
  name: "prescription",
  initialState,
  reducers: {
    setPrescriptionData: (state, action: PayloadAction<Partial<PrescriptionData>>) => {
      state.prescriptionData = { ...state.prescriptionData, ...action.payload };
    },
    updatePrescriptionData: (state, action: PayloadAction<Partial<PrescriptionData>>) => {
      state.prescriptionData = { ...state.prescriptionData, ...action.payload };
    },
    clearPrescriptionData: (state) => {
      state.prescriptionData = initialState.prescriptionData;
    },
    setPrescriptionLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPrescriptionVisitId: (state, action: PayloadAction<string | null>) => {
      state.visitId = action.payload;
    },
  },
});

export const {
  setPrescriptionData,
  updatePrescriptionData,
  clearPrescriptionData,
  setPrescriptionLoading,
  setPrescriptionVisitId,
} = prescriptionSlice.actions;

export default prescriptionSlice.reducer;
